import { Component, OnInit, Input, PLATFORM_ID, Inject } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { CustomDeviceDetectorService } from '../../services/CustomDeviceDetectorService';
import { isPlatformServer } from '@angular/common';
import { JssContextService } from '../../jss-context.service';
import { Subscription } from 'rxjs';
import { JssStylingService } from '../../JssStylingService';

@Component({
  selector: 'app-block-page-title',
  templateUrl: './block-page-title.component.html',
  styleUrls: ['./block-page-title.component.scss']
})
export class BlockPageTitleComponent implements OnInit {
  @Input() rendering: ComponentRendering;
  devicedetectorService: CustomDeviceDetectorService;
  isMobile: boolean;
  showImage: boolean = false;
  _isPlatformServer: boolean = false;
  metaTitle: string = "";
  metaDescription: string = "";
  metaUrl: string = "";
  private contextSubscription: Subscription;
  dynamicClass: string;
  jssStylingService: JssStylingService;

  constructor(jssStylingService: JssStylingService,devicedetectorService: CustomDeviceDetectorService, @Inject(PLATFORM_ID) public readonly platformId: string,public jssContext: JssContextService) { 
    this.devicedetectorService = devicedetectorService;
    this.jssStylingService = jssStylingService;
    platformId
  }

  ngOnInit() {
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
    this._isPlatformServer = isPlatformServer(this.platformId);
    this.contextSubscription = this.jssContext.state.subscribe((newState) => {
      this.metaTitle = (newState?.sitecore?.route?.fields?.MetaTitle as any)?.value;
      this.metaDescription = (newState?.sitecore?.route?.fields?.MetaDescription as any)?.value;
      this.metaUrl = (newState?.sitecore?.context as any)?.itemPath;
  });
    // remove this after implementation is done
    console.log('blockPageTitle component initialized with component data', this.rendering);
    var fields = (this.rendering.fields as any);
    this.isMobile = this.devicedetectorService.isMobile();
    this.showImage = this.isMobile ? fields.MobileImage?.value?.src != undefined  : fields.Image?.value?.src != undefined;
  }

  navigatorShare() {
    if (!this._isPlatformServer) {
        import("ng-navigator-share").then((navigatorShare) => {
            let ngNavigatorShareService = new navigatorShare.NgNavigatorShareService();
            if (!ngNavigatorShareService.canShare()) {
                alert(`This service/api is not supported in your Browser`);
                return;
              }
              ngNavigatorShareService.share({
                title: this.metaTitle,
                text: this.metaDescription,
                url: this.metaUrl
              })
            //   .then( (response) => {
            //   })
            //   .catch( (error) => {
            //   });                
        });     
    }
  }
  ngOnDestroy(): void {
    if (this.contextSubscription) {
        this.contextSubscription.unsubscribe();
    }
  }

}
